
const initState = {
	lockedPosts: {},
	usersOnline: {},
	connected: false,
	client: null,
};

const initGetters = {
	'socket/lockedPosts': state => state.lockedPosts,
	'socket/connected': state => state.connected,
	'socket/usersOnline': state => state.usersOnline,
	'socket/lockedPost': function (state) {
		return (postId) => {
			const post = state.lockedPosts[postId];

			let locked = false;
			if (post !== undefined) {
				Object.keys(post.users).forEach((u) => {
					if (u !== state.client) locked = true;
				});

				return {
					status: locked,
					users: post.users,
				};
			}

			return {
				status: locked,
				users: {},
			};
		};
	},
};

const initMutations = {
	SOCKET_SET_CONNECTION(state, value) {
		state.connected = value;
	},
	SOCKET_SET_CLIENT(state, client) {
		state.client = client;
	},
	SOCKET_SET_USERS_ONLINE(state, data) {
		const users = {};
		Object.keys(data).forEach((key) => {
			const u = data[key];
			if (u) {
				if (users[u.id] === undefined) {
					users[u.id] = ({ ...u, sessions: 1 });
				} else {
					users[u.id].sessions += 1;
				}
			}
		});

		state.usersOnline = users;
	},
	SOCKET_SET_LOCKED_POSTS(state, posts) {
		state.lockedPosts = posts;
	},
	SOCKET_CLEAN_DATA(state) {
		state.lockedPosts = {};
		state.usersOnline = {};
	},
};

const initActions = {
	// CONNECTION
	socketconnect({ commit }) {
		commit('SOCKET_SET_CONNECTION', true);
	},
	socketdisconnect({ commit }) {
		commit('SOCKET_SET_CONNECTION', false);
		commit('SOCKET_CLEAN_DATA');
	},
	socketusersOnline({ commit }, users) {
		commit('SOCKET_SET_USERS_ONLINE', users);
	},
	socketlockedPosts({ commit }, posts) {
		commit('SOCKET_SET_LOCKED_POSTS', posts);
	},
	socketwhoAreYou({ commit, getters }, client) {
		commit('SOCKET_SET_CLIENT', client);
		this.$socket.emit('connected', getters.user);
	},
};

export default {
	state: initState,
	getters: initGetters,
	actions: initActions,
	mutations: initMutations,
};
